// extracted by mini-css-extract-plugin
export default {"tag":"ConceptTags_tag__X87s4"};